import axios from 'axios'
import { Notification } from 'element-ui'

export async function applyForJob(formData, job, jobBoardId) {
  const data = {
    email: formData.email,
    salutation: formData.salutation,
    given_name: formData.given_name,
    family_name: formData.family_name,
    motivation_text: formData.motivation_text,
    cv: formData.cvToken,
    phone: formData.phone,
    phone_country: formData.phone_country || 'NL',
    job_board_id: jobBoardId,
    motivation: formData.motivation,
    newsletters: formData.newsletters,
    termsAccepted: formData.termsAccepted,
    candidate: formData.candidate,
  }
  try {
    const res = await axios.post(`/api/public/v1/jobs/${job.uuid}/apply`, data)
    return res.data
  } catch (error) {
    Notification.error({
      message: 'You cannot apply for this job. Most likely you have already applied for it.',
      dangerouslyUseHTMLString: true
    })
    throw error
  }
}
